import { useField, useFormikContext } from 'formik';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import {
	Female1Illustration,
	Female2Illustration,
	Female3Illustration,
	Female4Illustration,
	Female5Illustration,
	Man1Illustration,
	Man2Illustration,
	Man3Illustration,
	Man4Illustration,
	Man5Illustration,
} from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, Label, Slider, Subheading, Title } from '@treams/treams-ui';

const Axis = styled(Label)<{ start?: boolean; end?: boolean }>`
	user-select: none;
`;

export default function Face(props: { type: graphql.EngagementType }) {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const [{ value }, , { setValue }] = useField('answer.index');
	const [loading, setLoading] = useState(false);
	const formik = useFormikContext();

	const [illustrationRandom] = useState<number>(Math.random());
	const illustrations =
		illustrationRandom > 0.5
			? [Man1Illustration, Man2Illustration, Man3Illustration, Man4Illustration, Man5Illustration]
			: [
					Female1Illustration,
					Female2Illustration,
					Female3Illustration,
					Female4Illustration,
					Female5Illustration,
				];

	const titles = props.type.options?.map((option) => localize(option.title!).text);

	return (
		<Box width="100%">
			<Title mb={5} textAlign="center">
				<span style={{ fontSize: 64 }}>
					<img height="115" src={illustrations[value ?? 2]} alt="" />
				</span>
			</Title>

			<Box flexGrow={1} width="100%" maxWidth={670}>
				<Slider
					value={(value ?? 2) / (illustrations.length - 1)}
					onChange={(value) => {
						setValue(Math.round(value * (illustrations.length - 1)));
					}}
				/>

				{titles && (
					<>
						<Flex mt={3}>
							<Axis flexGrow={0} flexShrink={0} start>
								{titles[0]}
							</Axis>
							<Box flexGrow={1} flexShrink={1} />
							<Axis flexGrow={0} flexShrink={0} end>
								{titles[titles.length - 1]}
							</Axis>
						</Flex>
						<Flex mt={3} justifyContent="center">
							<Subheading>{titles[value ?? 2]}</Subheading>
						</Flex>
					</>
				)}
			</Box>

			{value !== undefined && (
				<Flex justifyContent="center">
					<Flex mt={4}>
						<Button
							loading={loading}
							title={t('engagement.respond.face.confirm')}
							onClick={async () => {
								setLoading(true);
								await formik.submitForm();
							}}
						/>
					</Flex>
				</Flex>
			)}
		</Box>
	);
}
